module.exports = __webpack_public_path__ + "img/violet_063.e9ce1d8a.png";